import React from 'react';

import { Badge } from '@vlabs/uikit';

export const filterIsApplied = (condition: boolean): React.JSX.Element | undefined => (condition ? <Badge shape="dot" /> : undefined);
